import PriceMinMax from "api/models/PriceMinMax";
import { isNil } from "ramda";

const shouldShowPrice = ({ min, max, free }: PriceMinMax) =>
  !isNil(min) || !isNil(max) || !!free;

export default shouldShowPrice;
